import type {
  CreateProjectPayload,
  DocumentType,
  ProjectDocument,
  ProjectWithTasks,
  UpdateProjectPayload,
} from '~/types';

import { apiRequest } from './client';
import { buildDocumentEndpoint, ENDPOINTS, HTTP_METHODS } from './config';

export async function createProject(project: CreateProjectPayload): Promise<ProjectWithTasks> {
  const response = await apiRequest<ProjectWithTasks>(ENDPOINTS.PROJECTS, {
    method: HTTP_METHODS.POST,
    body: JSON.stringify(project),
  });

  return response.data;
}

export async function deleteProject(id: string): Promise<void> {
  await apiRequest(`${ENDPOINTS.PROJECTS}/${id}`, {
    method: HTTP_METHODS.DELETE,
  });
}

export async function getDocumentContent(
  projectId: string,
  documentType: DocumentType,
): Promise<ProjectDocument> {
  const response = await apiRequest<ProjectDocument>(
    buildDocumentEndpoint(projectId, documentType),
  );

  return response.data;
}

export async function getProject(id: string): Promise<ProjectWithTasks> {
  const response = await apiRequest<ProjectWithTasks>(`${ENDPOINTS.PROJECTS}/${id}`);

  return response.data;
}

export async function getProjects(): Promise<ProjectWithTasks[]> {
  const response = await apiRequest<ProjectWithTasks[]>(ENDPOINTS.PROJECTS);

  return response.data;
}

export async function updateProject(
  id: string,
  updates: UpdateProjectPayload,
): Promise<ProjectWithTasks> {
  const response = await apiRequest<ProjectWithTasks>(`${ENDPOINTS.PROJECTS}/${id}`, {
    method: HTTP_METHODS.PATCH,
    body: JSON.stringify(updates),
  });

  return response.data;
}
